import * as React from 'react';

export const BackIcon = ({ width = 20, height = 17, fill = "#1E1E1E", ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 17"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.5006 10.5006C19.4989 12.0914 18.8662 13.6165 17.7413 14.7413C16.6165 15.8662 15.0914 16.4989 13.5006 16.5006H5.25059C5.05168 16.5006 4.86091 16.4216 4.72026 16.2809C4.57961 16.1403 4.50059 15.9495 4.50059 15.7506C4.50059 15.5517 4.57961 15.3609 4.72026 15.2203C4.86091 15.0796 5.05168 15.0006 5.25059 15.0006H13.5006C14.6941 15.0006 15.8387 14.5265 16.6826 13.6826C17.5265 12.8387 18.0006 11.6941 18.0006 10.5006C18.0006 9.30712 17.5265 8.16252 16.6826 7.31861C15.8387 6.4747 14.6941 6.00059 13.5006 6.00059H6.00059V9.75059C6.00071 9.89901 5.95678 10.0441 5.87438 10.1676C5.79198 10.291 5.6748 10.3872 5.53768 10.4441C5.40057 10.5009 5.24967 10.5157 5.10411 10.4867C4.95855 10.4578 4.82486 10.3862 4.71996 10.2812L0.219965 5.78122C0.150233 5.71156 0.0949133 5.62884 0.05717 5.5378C0.0194268 5.44675 0 5.34915 0 5.25059C0 5.15203 0.0194268 5.05443 0.05717 4.96339C0.0949133 4.87234 0.150233 4.78962 0.219965 4.71997L4.71996 0.219966C4.82486 0.114957 4.95855 0.0434315 5.10411 0.0144437C5.24967 -0.0145441 5.40057 0.00030937 5.53768 0.0571237C5.6748 0.113938 5.79198 0.210159 5.87438 0.333604C5.95678 0.457049 6.00071 0.602169 6.00059 0.750591V4.50059H13.5006C15.0914 4.50233 16.6165 5.13503 17.7413 6.25987C18.8662 7.38471 19.4989 8.90983 19.5006 10.5006Z"
      fill={fill}
      />
      </svg>
    );
};
